const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface ImportRowInput {
  name: string;
  email: string;
  company?: string;
  group?: string;
}

export interface ImportRowResult {
  ok: boolean;
  err?: string;
}

export function validateImportRow(
  row: ImportRowInput,
  existingEmails: Set<string>,
): ImportRowResult {
  if (!row.name?.trim()) {
    return { ok: false, err: 'Name is required' };
  }
  const email = row.email?.trim().toLowerCase() ?? '';
  if (!email) {
    return { ok: false, err: 'Email is required' };
  }
  if (!EMAIL_RE.test(email)) {
    return { ok: false, err: 'Invalid email format' };
  }
  if (existingEmails.has(email)) {
    return { ok: false, err: 'Email already exists (duplicate)' };
  }
  return { ok: true };
}
